import React from "react";
import Chart from "react-apexcharts";

const monthNames = [
  "JANUARY",
  "FEBRUARY",
  "MARCH",
  "APRIL",
  "MAY",
  "JUNE",
  "JULY",
  "AUGUST",
  "SEPTEMBER",
  "OCTOBER",
  "NOVEMBER",
  "DECEMBER",
];

const colorPalette = [
  "#E9EDF5",
  "#9932CC",
  "#c29bd6",
  "#d81694",
  "#1E90FF",
  "#FF4500",
];

function DoubleBarChartReal({ data = [] }) {
  const safeData = Array.isArray(data) ? data : [];
  const seriesMap = {};

  safeData.forEach((monthData) => {
    const { discoData, month } = monthData || {};

    if (!Array.isArray(discoData)) return;

    discoData.forEach((disco) => {
      if (!disco?.discoName) return;

      if (!seriesMap[disco.discoName]) {
        seriesMap[disco.discoName] = {
          name: disco.discoName,
          type: "column",
          data: Array(12).fill(0),
        };
      }

      const monthIndex = monthNames.indexOf(month);
      if (monthIndex !== -1) {
        seriesMap[disco.discoName].data[monthIndex] +=
          disco.transactionCount || 0;
      }
    });
  });

  const series = Object.values(seriesMap);

  // ApexCharts crashes on an empty series array
  if (series.length === 0) {
    return (
      <div className="flex items-center justify-center h-[290px] text-[12px] text-route-noncolor">
        No transaction data available
      </div>
    );
  }

  const colors = series.map(
    (_, index) => colorPalette[index % colorPalette.length]
  );

  const options = {
    colors,
    chart: {
      height: 290,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    grid: {
      show: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        borderRadius: 1,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      tickAmount: 10,
      min: 0,
      max: 2000,
    },
    fill: {
      opacity: 1,
    },
    legend: {
      show: true,
    },
  };

  return <Chart options={options} series={series} type="bar" height={290} />;
}

export default DoubleBarChartReal;
